import React from 'react';
import { Translation } from 'react-i18next';

import DashboardFormSection
  from 'components/dashboard/common/DashboardFormSection';
import BillingDetailsForm
  from 'components/dashboard/billing-content/BillingDetailsForm';

const BillingDetailsContent = () => (
  <Translation>
    {(t) => (
      <DashboardFormSection
        header={t("BILLING DETAILS")}
        className="billing-details-content__component"
      >
        <BillingDetailsForm />
      </DashboardFormSection>
    )}
  </Translation>
);

export default BillingDetailsContent;
